/**
 * scoring/index.js
 *
 * Central registry that maps sport names to their scorer class instances.
 * Use getSportScoring(sportName) everywhere instead of importing classes directly.
 */
import VolleyballScoring from './VolleyballScoring';
import BasketballScoring from './BasketballScoring';
import BadmintonScoring  from './BadmintonScoring';
import TennisScoring     from './TennisScoring';
import FootballScoring   from './FootballScoring';
import TableTennisScoring from './TableTennisScoring';
import { resolveMetricsKey } from '../../../../config/sportsMetrics';

// Singleton instances — instantiated once and reused.
const REGISTRY = {
  volleyball:         new VolleyballScoring(),
  basketball:         new BasketballScoring(),
  badminton:          new BadmintonScoring(false),
  badminton_doubles:  new BadmintonScoring(true),
  tennis:             new TennisScoring(false),
  tennis_doubles:     new TennisScoring(true),
  football:           new FootballScoring(),
  table_tennis:       new TableTennisScoring(),
};

/**
 * Return the sport scorer for a given sport name.
 * Falls back to null for unsupported sports (basic scoring only).
 *
 * @param {string} sportName  — any spelling ("Soccer", "Badminton Singles",
 *                              "Table Tennis", "Beach Volleyball"); resolved with
 *                              the shared sport resolver (LS-B15)
 * @returns {BaseSportScoring|null}
 */
export const getSportScoring = (sportName) => {
  const key = resolveMetricsKey(sportName);
  return key ? REGISTRY[key] ?? null : null;
};

export {
  VolleyballScoring,
  BasketballScoring,
  BadmintonScoring,
  TennisScoring,
  FootballScoring,
  TableTennisScoring,
};
